<template>
  <section
    class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-customer"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Item' : 'Tambah Item' }}</h5>
      </div>
      <div id="modal-body"
        class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <!-- Image Upload Section -->
        <div class="col-span-1 md:col-span-3">
          <div class="flex flex-col items-center justify-center w-full">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Foto Item</label>
            <div class="mt-1 flex items-center">

              <span v-if="!itemImagePreview"
                class="inline-block h-32 w-32 rounded-md text-primary/50 dark:text-primary/30 overflow-hidden">
                <PhotoIcon class="w-full h-full" />
              </span>
              <img v-else :src="itemImagePreview" alt="Item preview" class="h-32 w-32 object-cover rounded-md" />
              <div class="ml-4 flex text-sm">
                <label for="item-image"
                  class="relative cursor-pointer bg-white dark:bg-dark-800 rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none">
                  <span>Upload a file</span>
                  <input id="item-image" name="item-image" type="file" class="sr-only" @change="handleImageUpload"
                    accept="image/*" />
                </label>
                <p v-if="!itemImagePreview" class="pl-1">or drag and drop</p>
                <button v-else type="button" @click="removeImage" class="ml-2 text-red-600 hover:text-red-500">
                  Hapus
                </button>
              </div>
            </div>
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
              PNG, JPG, GIF up to 2MB
            </p>
          </div>
        </div>
        <!-- End Image Upload Section -->
        <InputTextCustom v-model="itemName" id="item-name" label="Nama Item" placeholder="Masukkan nama item"
          :valid="validation.name.valid" :error-message="validation.name.message" />
        <InputSelect v-model="selectedCategoryId" id="category-select" label="Category" :options="optionItemCategories"
          placeholder="Pilih kategori" :valid="validation.item_category_id.valid"
          :error-message="validation.item_category_id.message" :isScrolled="true" />
        <InputSelect v-model="itemUnitId" id="satuan-unit" label="Satuan" :options="optionUnits"
          placeholder="Pilih satuan" :valid="validation.unit_id.valid" :error-message="validation.unit_id.message"
          :isScrolled="true" />
        <InputRupiah v-model="itemPrice" id="item-price" label="Harga" input_class="w-full"
          :valid="validation.sale_price.valid" :error-message="validation.sale_price.message" />
        <InputNumberCustom v-model="itemDiscountPercent" id="item-discount-percent" label="Diskon (%)" input_class="w-full"/>
        <InputRupiah v-model="itemDiscountPrice" id="item-discount-price" label="Diskon (Rp)" input_class="w-full"
          :valid="validation.discount_price.valid" :error-message="validation.discount_price.message" />
        <div class="flex items-center gap-2">
          <input type="checkbox" v-model="itemMonitorStock"
            class="w-4 h-4 text-primary focus:ring-primary-500 rounded hover:text-primary-700 dark:hover:text-primary-50" /><span
            class="text-dark-600 dark:text-dark-50"> Monitor Stok</span>
        </div>
        <InputRadio v-model="serviceChargeApplied" id="service-charge-applied" name="service-charge-applied"
          label="Service Charge" :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.service_charge_applied.valid" :error-message="validation.service_charge_applied.message" />
        <InputRadio v-model="taxApplied" id="tax-applied" name="tax-applied" label="Pajak"
          :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.tax_applied.valid" :error-message="validation.tax_applied.message" />
        <InputRadio v-model="discountApplied" id="discount-applied" name="discount-applied" label="Diskon"
          :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.discount_applied.valid" :error-message="validation.discount_applied.message" />
        <!-- <InputRupiah v-model="itemPurchasePrice" id="item-purchase-price" label="Harga" input_class="w-full"
          :valid="validation.purchase_price.valid" :error-message="validation.purchase_price.message" /> -->
        <!-- Outlet Selection -->
        <div v-if="allowedRoles.includes(role_id)" class="col-span-1 md:col-span-2 lg:col-span-3">
          <InputSelect v-if="isMix && !isEdit" v-model="itemOutletIds[0]" id="satuan-unit" label="Outlet"
            :options="allOutlets" option-label="name" option-value="id" placeholder="Pilih satuan"
            :valid="validation.unit_id.valid" :error-message="validation.unit_id.message" :isScrolled="true" />
          <div v-if="isEdit">
            <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Disimpan ke Outlet
            </label>
            <label class="block mb-2 text-lg font-bold text-gray-700 dark:text-gray-300">
              {{ getOutletName(itemOutletId) }}
            </label>
          </div>
          <InputMultiSelect v-if="!isMix && !isEdit" v-model="itemOutletIds" :options="allOutlets" option-label="name"
            option-value="id" placeholder="Pilih Outlet" :valid="validation.outlet_ids.valid"
            :error-message="validation.outlet_ids.message" :isScrolled="true" label="Outlet" id="outlet-select" />
        </div>
        <div class="flex items-center gap-2">
          <input type="checkbox" v-model="isMix"
            class=" text-primary focus:ring-primary-500 rounded hover:text-primary-700 dark:hover:text-primary-50" /><span
            class="text-dark-600 dark:text-dark-50"> Produk MIX</span>
        </div>
        <div v-if="isMix" class="col-span-1 md:col-span-3 lg:col-span-3">
          <label for="item-min-qty-per-unit" class="font-medium text-primary dark:text-dark-50">Jumlah Item</label>
          <div class="flex items-center space-x-2">
            <button @click="reduceMixQtyPerUnit()" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
              <MinusCircleIcon class="h-5 w-5" />
            </button>
            <div class="w-24">
              <InputTextCustom v-model="itemMixQtyPerUnit" id="item-min-qty-per-unit" type="number"
                placeholder="Jumlah item" :valid="validation.mix_qty_per_unit.valid"
                :error-message="validation.mix_qty_per_unit.message" min="1" />
            </div>
            <button @click="addMixQtyPerUnit()" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
              <PlusCircleIcon class="h-5 w-5" />
            </button>
          </div>
          <div class="overflow-x-auto mt-4">
            <div class="inline-block min-w-full align-middle">
              <div class="overflow-y-auto shadow-lg rounded-lg">
                <TableComponent>
                  <TableHead>
                    <TableRow>
                      <TableHeadCell>Action</TableHeadCell>
                      <TableHeadCell>Maksimal Jumlah</TableHeadCell>
                      <TableHeadCell>Produk</TableHeadCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow v-if="allItems.length == 0">
                      <TableCell colspan="12" customClass="text-center italic text-gray-400 dark:text-gray-500"
                        noTextColor>
                        Belum ada data
                      </TableCell>
                    </TableRow>
                    <TableRow v-else v-for="(item, index) in allItems" :key="item.id" :index="index" isBody>
                      <TableCell>
                        <div class="flex items-center">
                          <button v-if="!isSelectedItemMix(item)" :id="'edit-data-' + item.id"
                            @click="selectItemMix(item)"
                            class="bg-success hover:bg-hover-success flex justify-center items-center mx-1 p-2 rounded-md group">
                            <CheckIcon class="h-4 w-4 text-light-50 group-hover:text-primary" size="2.4x" />
                          </button>
                          <button v-else :id="'edit-data-' + item.id" @click="deleteItemMix(item)"
                            class="bg-danger hover:bg-hover-danger flex justify-center items-center mx-1 p-2 rounded-md group">
                            <TrashIcon class="h-4 w-4 text-light-50 group-hover:text-primary" size="2.4x" />
                          </button>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div class="flex items-center rounded-lg p-1">
                          <button @click="reduceItem(item)"
                            class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                            <MinusCircleIcon class="h-5 w-5 dark:text-light-50" />
                          </button>
                          <InputTextCustom v-model="(itemMix.find(detail => detail.id === item.id) || {}).max_qty"
                            id="item-max-qty" type="number" div_class="w-20" min="1" @input="inputQty(item)" />
                          <button @click="addItem(item)"
                            class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                            <PlusCircleIcon class="h-5 w-5 dark:text-light-50" />
                          </button>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div class="flex flex-col space-y-2">
                          <div class="flex items-center justify-between">
                            <div class="flex items-center space-x-2">
                              <span class="text-lg font-bold dark:text-light-50 truncate max-w-[200px]">
                                {{ item.name }}
                              </span>
                              <CheckCircleIcon v-if="isSelectedItemMix(item)" class="h-5 w-5 text-success" />
                            </div>
                            <span :class="[
                              'text-xs font-semibold px-3 py-1 rounded-full',
                              item.is_active
                                ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                                : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                            ]">
                              {{ item.is_active ? 'Aktif' : 'Tidak Aktif' }}
                            </span>
                          </div>

                          <div class="text-xl font-bold text-primary dark:text-primary-300">
                            {{ formatRupiah(item.sale_price) }}
                          </div>

                          <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-sm text-gray-600 dark:text-gray-300">
                            <div class="flex items-center">
                              <span class="font-medium w-16">Code:</span>
                              <span class="truncate">{{ item.code || '-' }}</span>
                            </div>
                            <div class="flex items-center">
                              <span class="font-medium w-20">Category:</span>
                              <span class="truncate">{{ getCategoryName(item.item_category_id) || '-' }}</span>
                            </div>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </TableComponent>
                <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
                <Message v-if="!valid" size="small" severity="error" variant="simple">{{ validation.product_mix.message
                }}
                </Message>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
            @click="closeModal" />
          <Button type="submit" label="Simpan" :loading="loading" @click="submitItem" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import SubmitButton from '../form/SubmitButton.vue';
  import InputRupiah from '../form/InputRupiah.vue';
  import { mapActions, mapGetters } from 'vuex';
  import InputTextCustom from '../form/InputTextCustom.vue';
  import InputSelect from '../form/InputSelect.vue';
  import InputRadio from '../form/InputRadio.vue';
  import { formatRupiah } from '@/helpers/formatRupiah';
  import {
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  } from "@/components/table";
  import PaginationButtons from '@/components/PaginationButtons.vue';
  import { CheckIcon, TrashIcon, MinusCircleIcon, PlusCircleIcon, CheckCircleIcon } from '@heroicons/vue/24/solid';
  import { Message } from 'primevue';
  import { Button } from 'primevue';
  import { PhotoIcon } from '@heroicons/vue/24/outline';
  import InputMultiSelect from '../form/InputMultiSelect.vue';
  import InputNumberCustom from '../form/InputNumberCustom.vue';

  export default {
    name: "ModalItem",
    props: {
      item: {
        type: Object,
        default: null,
      }
    },
    components: {
      SubmitButton, InputRupiah, InputTextCustom, InputSelect, InputRadio, TableComponent,
      TableHead, TableRow, TableHeadCell, TableBody, TableCell, CheckIcon, TrashIcon,
      MinusCircleIcon, PlusCircleIcon, CheckCircleIcon,
      PaginationButtons, Message, Button, PhotoIcon, InputMultiSelect, InputNumberCustom
    },
    data() {
      const percentDiscount = this.item ? (this.item.discount_price / this.item.sale_price) * 100 : 0;
      return {
        allowedRoles: ['null', '4'],
        role_id: localStorage.getItem('role_id'),
        showModal: true,
        itemName: this.item ? this.item.name : '',
        selectedCategoryId: this.item ? this.item.item_category_id : '',
        // selectedMenuType: this.item ? this.item.menu_type : '',
        itemUnitId: this.item ? this.item.unit_id : '',
        itemPrice: this.item ? this.item.sale_price : 0,
        serviceChargeApplied: this.item ? this.item.service_charge_applied : null,
        taxApplied: this.item ? this.item.tax_applied : null,
        discountApplied: this.item ? this.item.discount_applied : null,
        itemDiscountPrice: this.item ? this.item.discount_price : 0,
        itemDiscountPercent: percentDiscount,
        itemPurchasePrice: this.item ? this.item.purchase_price : 0,
        itemMonitorStock: this.item ? this.item.monitor_stock : false,
        itemIsMix: this.item ? this.item.is_mix : false,
        itemOutletId: this.item ? this.item.outlet_id : false,
        isMix: this.item ? this.item.has_product_mix : false,
        itemMix: this.item ? this.item.product_mix.map(item => {
          return {
            ...item,
            max_qty: item.max_qty || 1
          }
        }) : [],
        itemMixQtyPerUnit: this.item ? this.item.mix_qty_per_unit : null,
        optionItemCategories: [],
        optionUnits: [],
        isEdit: !!this.item,
        menuTypes: [
          { id: 'food', name: 'Makanan' },
          { id: 'drink', name: 'Minuman' }
        ],
        validation: {
          unit_id: {
            valid: true,
            message: ''
          },
          name: {
            valid: true,
            message: ''
          },
          description: {
            valid: true,
            message: ''
          },
          sale_price: {
            valid: true,
            message: ''
          },
          discount_price: {
            valid: true,
            message: ''
          },
          item_category_id: {
            valid: true,
            message: '',
          },
          service_charge_applied: {
            valid: true,
            message: '',
          },
          tax_applied: {
            valid: true,
            message: '',
          },
          discount_applied: {
            valid: true,
            message: '',
          },
          has_product_mix: {
            valid: true,
            message: '',
          },
          product_mix: {
            valid: true,
            message: '',
          },
          mix_qty_per_unit: {
            valid: true,
            message: '',
          },
          outlet_ids: {
            valid: true,
            message: '',
          },
        },
        field: ['unit_id', 'name', 'description', 'sale_price', 'item_category_id', 'discount_applied', 'service_charge_applied', 'tax_applied', 'discount_price', 'has_product_mix', 'product_mix', 'mix_qty_per_unit'],
        currentPage: 1,
        totalPages: 1,
        loading: false,
        loadingCategories: false,
        loadingUnits: false,
        categoryPagination: {
          page: 1,
          limit: 20,
          hasMore: true
        },
        unitPagination: {
          page: 1,
          limit: 20,
          hasMore: true
        },
        itemImage: null,
        itemImagePreview: this.item && this.item.image_url ? `${process.env.VUE_APP_WEBSOCKET_URL}/file/${this.item.image_url}` : null,
        itemOutletIds: this.item ? [this.item.outlet_id] : [],
        fetchItemsTimeout: null,
      }
    },
    computed: {
      ...mapGetters('item_categories', ['allItemCategories']),
      ...mapGetters('units', ['allUnits']),
      ...mapGetters('outlets', ['allOutlets']),
      ...mapGetters('items', {
        allItems: 'allItems',
      })
    },
    async created() {
      await Promise.all([
        this.$store.dispatch('outlets/fetchOutlets', { limit: 1000 }),
        this.$store.dispatch('item_categories/fetchItemCategories', { limit: 1000, status: 'active' }),
        this.$store.dispatch('units/fetchUnits', { limit: 1000 }),
      ]);
      this.optionItemCategories = this.allItemCategories.map(category => ({ label: category.name, value: category.id }));
      this.optionUnits = this.allUnits.map(unit => ({ label: unit.name, value: unit.id }));
      const percentDiscount = this.item ? (this.item.discount_price / this.item.sale_price) * 100 : 0;
      this.itemDiscountPercent = percentDiscount;
    },
    watch: {
      item(newVal) {
        if (newVal) {
          const percentDiscount = this.item ? (this.item.discount_price / this.item.sale_price) * 100 : 0;
          this.itemName = newVal.name;
          this.selectedCategoryId = newVal.category_id;
          this.selectedMenuType = newVal.menu_type;
          this.itemUnitId = newVal.unit_id;
          this.itemPrice = newVal.sale_price || 0;
          this.serviceChargeApplied = newVal.service_charge_applied || false;
          this.taxApplied = newVal.tax_applied || false;
          this.discountApplied = newVal.discount_applied || false;
          this.itemDiscountPrice = newVal.discount_price || 0;
          this.itemPurchasePrice = newVal.purchase_price || 0;
          this.itemMonitorStock = newVal.monitor_stock || false;
          this.itemDiscountPercent = percentDiscount;
          this.itemMix = newVal.product_mix.map(item => {
            return {
              ...item,
              max_qty: item.max_qty || 1
            }
          }) || [];
          this.isEdit = true;

          // Set image preview if existss
          if (newVal.image_url) {
            this.itemImagePreview = process.env.VUE_APP_WEBSOCKET_URL + newVal.image_url;
          }
        } else {
          this.resetForm();
        }
      },
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchItems({ page: newVal });
        },
      },
      itemOutletIds: {
        handler(newVal) {
          if (newVal && newVal[0]) {
            this.itemMix = [];
            // Clear any existing timeout to prevent multiple rapid calls
            if (this.fetchItemsTimeout) {
              clearTimeout(this.fetchItemsTimeout);
            }
            // Set a new timeout
            this.fetchItemsTimeout = setTimeout(() => {
              this.fetchItems({ page: 1 });
            }, 1500);
          }
        },
        deep: true
      },
      itemDiscountPercent: {
        handler(newVal) {
          this.itemDiscountPrice = (newVal / 100) * this.itemPrice;
        }
      },
      itemDiscountPrice: {
        handler(newVal) {
          this.itemDiscountPercent = (newVal / this.itemPrice) * 100;
        }
      },
      isMix: {
        handler(newVal) {
          if (newVal) {
            this.fetchItems({ page: 1 });
          }
        }
      }
    },
    methods: {
      ...mapActions('items', ['createItem', 'updateItem', 'createBulkItem']),
      getOutletName(outletId) {
        const outlet = this.allOutlets.find((outlet) => outlet.id === outletId);
        return outlet && outletId ? outlet.name : "-";
      },
      async fetchItems(params = {}) {
        try {
          let filterFetchItems = {
            limit: 1000,
            has_product_mix: false,
          };
          if (this.isMix && this.allowedRoles.includes(this.role_id)) {
            filterFetchItems.outlet_id = this.itemOutletIds[0] ? this.itemOutletIds[0] : 0;
          }
          // 1. First, fetch all items with a large limit
          const response = await this.$store.dispatch("items/fetchItems", filterFetchItems);

          if (!response) {
            return;
          }

          // 2. Get all items from the store with proper null checking
          const storeItems = this.$store.getters["items/allItems"];

          if (!Array.isArray(storeItems)) {
            return;
          }

          let allItems = [...storeItems];


          if (allItems.length === 0) {
            // Reset store with empty array to prevent undefined errors
            this.$store.commit("items/resetItems");
            this.$store.commit("items/setItems", []);
            this.totalPages = 1;
            this.currentPage = 1;
            return;
          }

          if (this.item) {
            allItems = allItems.filter(item => item.id !== this.item.id);
          }

          // 3. Get IDs of selected items (checking both id and item_id for compatibility)
          const selectedIds = Array.isArray(this.itemMix)
            ? this.itemMix.map(item => item?.id || item?.item_id).filter(Boolean)
            : [];

          // 4. Sort items - selected items first, then by active status, and finally by their original order
          const sortedItems = [...allItems].sort((a, b) => {
            if (!a || !b) {
              return 0;
            }
            // Check if items are selected
            const aSelected = selectedIds.includes(a.id);
            const bSelected = selectedIds.includes(b.id);

            // Selected items come first
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;

            // Then sort by active status (active first)
            if (a.is_active && !b.is_active) return -1;
            if (!a.is_active && b.is_active) return 1;

            // Maintain original order for items with same status
            return 0;
          });

          // 5. Apply client-side pagination
          const page = params.page || 1;
          const limit = params.limit || 25;
          const startIndex = (page - 1) * limit;
          const paginatedItems = sortedItems.slice(startIndex, startIndex + limit);

          // 6. Update store with paginated and sorted items
          this.$store.commit("items/resetItems");
          this.$store.commit("items/setItems", {
            data: paginatedItems,
            pagination: {
              total: sortedItems.length,
              totalPages: Math.ceil(sortedItems.length / limit),
              currentPage: page,
              perPage: limit
            }
          });

          // 7. Update pagination info based on all items
          this.totalPages = Math.ceil(sortedItems.length / limit);
          this.currentPage = page;

        } catch (error) {
          console.error('Error in fetchItems:', error);
          console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            params
          });
          // Reset to empty state on error
          this.$store.commit("items/resetItems");
          this.$store.commit("items/setItems", []);
          this.totalPages = 1;
          this.currentPage = 1;
        }
      },
      formatRupiah,
      addItem(item) {
        const existingItem = this.itemMix.find(detail => detail.id === item.id);
        if (existingItem) {
          // Each item can have max_qty up to itemMixQtyPerUnit
          if (existingItem.max_qty < this.itemMixQtyPerUnit) {
            existingItem.max_qty = Number(existingItem.max_qty) + 1;
            existingItem.isEdit = true;
          } else {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: `Jumlah maksimal per item adalah ${this.itemMixQtyPerUnit}`, life: 3000 });
          }
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Item tidak ditemukan. Pilih item terlebih dahulu', life: 3000 });
        }
      },
      reduceItem(item) {
        const existingItem = this.itemMix.find(detail => detail.id === item.id);
        if (existingItem) {
          existingItem.max_qty = Number(existingItem.max_qty) > 1 ? Number(existingItem.max_qty) - 1 : 1;
          existingItem.isEdit = true;
        }
      },
      inputQty(item) {
        const existingItem = this.itemMix.find(detail => detail.id === item.id);
        if (existingItem) {
          // Ensure max_qty doesn't exceed itemMixQtyPerUnit
          if (existingItem.max_qty > this.itemMixQtyPerUnit) {
            existingItem.max_qty = this.itemMixQtyPerUnit;
            this.$toast.add({ severity: 'error', summary: 'Error', detail: `Jumlah maksimal per item adalah ${this.itemMixQtyPerUnit}`, life: 3000 });
          } else {
            // Ensure max_qty is at least 1
            existingItem.max_qty = Number(existingItem.max_qty) <= 0 ? 1 : existingItem.max_qty;
            existingItem.isEdit = true;
          }
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Item tidak ditemukan. Pilih item terlebih dahulu', life: 3000 });
        }
      },
      selectItemMix(item) {
        // Allow adding any number of different items
        // Each item will have its own max_qty limit set to itemMixQtyPerUnit
        {
          this.itemMix.push({
            id: item.id,
            name: item.name,
            quantity: 1,
            max_qty: 1,
            price: item.sale_price,
            category_id: item.item_category_id,
            discount_price: item.discount_price,
            discount_applied: item.discount_applied,
            tax_applied: item.tax_applied,
            service_charge_applied: item.service_charge_applied,
            outlet_id: item.outlet_id,
          });
          this.fetchItems({ page: this.currentPage });
        }
      },
      addMixQtyPerUnit() {
        this.itemMixQtyPerUnit = Number(this.itemMixQtyPerUnit) + 1;
      },
      reduceMixQtyPerUnit() {
        this.itemMixQtyPerUnit = Number(this.itemMixQtyPerUnit) > 1 ? Number(this.itemMixQtyPerUnit) - 1 : 1;
      },
      isSelectedItemMix(item) {
        return this.itemMix.find(mix => mix.id === item.id) ? true : false;
      },
      deleteItemMix(item) {
        this.itemMix = this.itemMix.filter(mix => mix.id !== item.id);
        this.fetchItems({ page: this.currentPage });
      },
      getCategoryName(categoryId) {
        const category = this.allItemCategories.find(cat => cat.id === categoryId);
        return category ? category.name : 'Tidak ada kategori';
      },
      closeModal() {
        this.showModal = false;
        setTimeout(() => {
          this.$emit('closeModal');
        }, 200);
      },
      submitItem() {
        this.$confirm.require({
          group: 'headless',
          header: 'Apakah anda yakin ingin menyimpan item?',
          message: 'Silahkan konfirmasi sebelum diproses.',
          acceptLabel: 'Ya',
          rejectLabel: 'Tidak',
          accept: () => {
            this.postItem();
          },
          reject: () => {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
          }
        });
      },
      async postItem() {
        try {
          this.loading = true;

          const formData = new FormData();

          let responseUpload = false;
          if (this.itemImage) {
            formData.append('image', this.itemImage);
            responseUpload = await this.$store.dispatch('upload/upload', formData);
          }

          const itemData = {
            name: this.itemName,
            item_category_id: this.selectedCategoryId,
            menu_type: 'food',
            unit_id: this.itemUnitId,
            sale_price: parseInt(this.itemPrice) || 0,
            service_charge_applied: this.serviceChargeApplied,
            tax_applied: this.taxApplied,
            discount_applied: this.discountApplied,
            discount_price: parseInt(this.itemDiscountPrice) || 0,
            purchase_price: 0,
            monitor_stock: this.itemMonitorStock,
            saleable: true,
            has_product_mix: this.isMix,
            product_mix: this.itemMix,
            mix_qty_per_unit: this.itemMixQtyPerUnit,
            image_url: null
          };

          if (responseUpload && responseUpload?.status === 'success') {
            itemData.image_url = responseUpload?.data;
          }

          if (this.allowedRoles.includes(this.role_id) && !this.isEdit) {
            delete itemData.outlet_id;
            itemData.outlet_ids = this.itemOutletIds;
          } else if (this.allowedRoles.includes(this.role_id) && this.isEdit) {
            delete itemData.outlet_ids;
            itemData.outlet_id = this.item.outlet_id;
          }

          if (this.allowedRoles.includes(this.role_id) && !this.isEdit && this.isMix) {
            delete itemData.outlet_ids;
            itemData.outlet_id = this.itemOutletIds[0];
          }

          if (this.isEdit && this.item) {
            itemData.id = this.item.id;
            await this.updateItem(itemData);
          } else {
            itemData.is_active = false;
            if (this.allowedRoles.includes(this.role_id) && !this.isMix) {
              await this.createBulkItem(itemData);
            } else {
              await this.createItem(itemData);
            }
          }

          this.$emit('refresh');
          this.closeModal();

          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: `Item berhasil ${this.isEdit ? 'diperbarui' : 'ditambahkan'}`,
            life: 3000
          });

        } catch (error) {
          console.error('Error saving item:', error);
          const errorMessage = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan item';

          if (error.response?.status === 422) {
            this.validationErrors(errorMessage);
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: errorMessage,
              life: 3000
            });
          }
        } finally {
          this.loading = false;
        }
      },
      handleImageUpload(event) {
        const file = event.target.files[0];
        if (!file) return;

        // Check file size (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ukuran file maksimal 2MB',
            life: 3000
          });
          return;
        }

        // Check file type
        if (!file.type.match('image.*')) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Hanya file gambar yang diizinkan',
            life: 3000
          });
          return;
        }

        this.itemImage = file;

        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.itemImagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      removeImage() {
        this.itemImage = null;
        this.itemImagePreview = null;
        // Clear file input
        const fileInput = document.getElementById('item-image');
        if (fileInput) {
          fileInput.value = '';
        }
      },
      validationErrors(errorMessage) {
        for (let index = 0; index < this.field.length; index++) {
          this.validation[this.field[index]].valid = true;
          this.validation[this.field[index]].message = '';
        }

        errorMessage.forEach((error) => {
          if (this.validation[error.field]) {
            this.validation[error.field].valid = false;
            this.validation[error.field].message = error.message;
          }
        });
      },
      async onLazyLoadCategories(event) {
        try {
          if (!this.categoryPagination.hasMore || this.loadingCategories) return;

          this.loadingCategories = true;

          const response = await this.$store.dispatch('item_categories/fetchItemCategories', {
            page: this.categoryPagination.page,
            limit: this.categoryPagination.limit,
            ...event.filters
          });

          if (response.data.length < this.categoryPagination.limit) {
            this.categoryPagination.hasMore = false;
          } else {
            this.categoryPagination.page++;
          }

          // Trigger virtual scroller update
          event.load();
        } catch (error) {
          console.error('Error loading more categories:', error);
        } finally {
          this.loadingCategories = false;
        }
      },
      async onLazyLoadUnits(event) {
        try {
          if (!this.unitPagination.hasMore || this.loadingUnits) return;

          this.loadingUnits = true;

          const response = await this.$store.dispatch('units/fetchUnits', {
            page: this.unitPagination.page,
            limit: this.unitPagination.limit,
            ...event.filters
          });

          if (response.data.length < this.unitPagination.limit) {
            this.unitPagination.hasMore = false;
          } else {
            this.unitPagination.page++;
          }

          // Trigger virtual scroller update
          event.load();
        } catch (error) {
          console.error('Error loading more units:', error);
        } finally {
          this.loadingUnits = false;
        }
      },
      resetForm() {
        this.itemName = '';
        this.selectedCategoryId = '';
        this.itemUnitId = '';
        this.itemPrice = 0;
        this.itemDiscountPrice = 0;
        this.itemMonitorStock = false;
        this.serviceChargeApplied = false;
        this.taxApplied = false;
        this.discountApplied = false;
        this.isMix = false;
        this.itemImage = null;
        this.itemImagePreview = null;
        this.validation = {
          name: { valid: true, message: '' },
          item_category_id: { valid: true, message: '' },
          unit_id: { valid: true, message: '' },
          sale_price: { valid: true, message: '' },
          discount_price: { valid: true, message: '' },
          mix_qty_per_unit: { valid: true, message: '' }
        };
      },
    }
  }
</script>